import {
  GET_SOFTSKILLS_SURVEY,
  GET_SOFTSKILLS_SURVEY_SUCCESS,
  GET_SOFTSKILLS_SURVEY_CLEAN,
  GET_SOFTSKILLS_SURVEY_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  survey: undefined,
}

const SoftskillsSurveyGet = (state = initialState, action) => {
  switch (action.type) {
    case GET_SOFTSKILLS_SURVEY:
      state = {
        ...state,
        loading: true,
      }
      break
    case GET_SOFTSKILLS_SURVEY_SUCCESS:
      state = {
        ...state,
        survey: action.payload.survey,
        loading: false,
        done: true,
      }
      break
    case GET_SOFTSKILLS_SURVEY_CLEAN:
      state = initialState
      break
    case GET_SOFTSKILLS_SURVEY_ERROR:
      state = { ...state, error: action.payload, loading: false, done: false }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default SoftskillsSurveyGet
